<template>
  <el-table-column
    prop="customer_name"
    sortable="custom"
    label="Átvevő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      #{{ scope.row.customer_id }} {{ scope.row.customer_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer_name',
};
</script>
